import Lottie from 'lottie-react';
import { Box, Typography } from '@mui/material';
import { CustomButton } from '../../../MUI_custom_component';
import BirthdayAnimation from '../../../../utils/Lottie/Birthday.json';

const GRADIENTS = {
  Birthday:
    'linear-gradient(119.49deg, rgba(255,255,255,0.5) 0%, rgba(216,247,255,0.6) 36.87%, rgb(223,255,223) 98.31%)',
  Anniversary:
    'linear-gradient(134.28deg, rgba(255,255,255,0.5) 0%, rgba(255,216,228,0.6) 36.865%, rgb(223,230,255) 98.306%)',
};

const CelebrationCard = ({ occasion = 'Birthday', title, subtitle, onViewGift = () => {} }) => {
  const gradient = GRADIENTS[occasion] || GRADIENTS.Birthday;

  return (
    <Box
      sx={{
        background: gradient,
        borderRadius: '16px',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        gap: 1,
      }}
    >
      {/* Top: heading + subtext */}
      <Box sx={{ display: 'flex', flexDirection: 'column'}}>
        <Typography variant='h1' sx={{ color: '#333' }}>
          {title}
        </Typography>
        <Typography variant='bodyL' sx={{ color: '#333' }}>
          {subtitle}
        </Typography>
      </Box>

      {/* Bottom row: button (left) + Lottie gift box (right) */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
          <CustomButton
            variant='filled'
            color='primary'
            size='small'
            label='View your gift!'
            onClick={onViewGift}
          />
        <Box sx={{ flex: '0 0 40%', overflow: 'hidden' }}>
          <Lottie
            animationData={BirthdayAnimation}
            loop
            style={{ width: '100%', height: 'auto' }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CelebrationCard;
